import { Card } from '@nextui-org/react'
import { SliceTooltipProps } from '@nivo/line'
import { FC } from 'react'

export type PlotTooltipProps = {
  item: SliceTooltipProps
}

export const TimeTooltip: FC<PlotTooltipProps> = ({ item }) => {
  const timeUnitOptions: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  }

  return (
    <Card className="w-[25dvh] h-fill">
      {item.slice.points.map((value) => {
        return (
          <div key={value.id} className="flex flex-row items-start justify-between gap-2 p-2">
            <div className="mt-[2px]">
              <svg width="10" height="10" aria-hidden="true">
                <rect width="10" height="10" fill={value.color} />
              </svg>
            </div>
            <div className="flex-1 text-left text-xs">
              <div>
                {(() => {
                  const tankName = String(value.serieId)
                  return `Tank: ${tankName}`
                })()}
              </div>
              <div>
                Date: {(value.data.x as Date).toLocaleDateString('en-US', timeUnitOptions)}
              </div>
              <div>Value: {Number(Number(value.data.y).toFixed(2)).toLocaleString()}</div>
            </div>
          </div>
        )
      })}
    </Card>
  )
}
